@if (shouldShowActions()) {
  <mat-expansion-panel expanded="true" class="user-actions-panel">
    <mat-expansion-panel-header>
      <mat-panel-title transloco="ACTIONS"></mat-panel-title>
    </mat-expansion-panel-header>
    <div class="workflow-actions">
      @for (action of userActionsWithOverrides(); track action.key) {
        <div [matTooltip]="action.disabledMessage">
          <button
            class="action-button"
            [disabled]="buttonsDisabled() || !action.enabled"
            mat-button
            (click)="onClickUserAction(action)"
          >
            {{ action.name }}
          </button>
        </div>
      }
    </div>
  </mat-expansion-panel>
}
